// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberFormatter_root__tKLoz"};